export const environment = {
	enableProdMode: true,
	basePath: '/SalesPortal/',
	assetPath: '/SalesPortal/NgESP/dist/assets/',
	DISABLE_AUTH: false
};
// Remove console logging in production
(function () {
	let method;
	const noop = function () { };
	const methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeStamp', 'trace', 'warn'
	];
	let length = methods.length;
	const console = (window.console || {});

	while (length--) {
		method = methods[length];
		console[method] = noop;
	}
}());

